var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { errorHandler, formatTags, getRequestInfo, level2color, prettyPrint, } from "./utils";
/**
 * 自定义日志
 * @param name 日志信息名
 * @param tags 日志详情键值对
 */
var custom = function (name, tags) {
    if (tags === void 0) { tags = {}; }
    try {
        var requestInfo = getRequestInfo(tags);
        if (requestInfo && requestInfo.level !== "custom") {
            capture(requestInfo.level, name, requestInfo.describe, new Error(""), requestInfo.extra);
            return;
        }
        var _a = requestInfo
            ? formatTags(__assign(__assign({}, requestInfo.extra), { describe: requestInfo.describe }))
            : formatTags(tags), metrics = _a[0], categories = _a[1];
        if (window.SlardarWeb) {
            window.SlardarWeb("sendEvent", {
                type: "event",
                name: name,
                metrics: metrics,
                categories: categories,
            });
            // 本地打印日志
            prettyPrint({ label: "custom =>" }, name, metrics, categories);
        }
    }
    catch (e) {
        // console.error('Slardar Web sendEvent 错误', e);
    }
};
var capture = function (level, label, describe, error, tags) {
    if (error === void 0) { error = new Error(""); }
    if (tags === void 0) { tags = {}; }
    try {
        var detail = errorHandler(level, label, describe, error, tags);
        var extra = detail.extra;
        var err = detail.error;
        err.message = "[".concat(detail.label, "] - ").concat(detail.describe);
        // 本地打印
        prettyPrint({ label: "".concat(detail.level, " =>"), color: level2color(detail.level) }, err.message, err, extra);
        window.SlardarWeb("captureException", err, extra);
    }
    catch (e) {
        // console.error("Slardar Web 内部错误", e);
    }
};
/**
 * 需要加急你的错误
 * @params level 错误级别，"fatal" | "error" | "warn"
 * @param label 标记 标示自己的业务模块 必填
 * @param describe 描述 必填
 * @param error Error 选填
 * @param tags 额外信息 选填
 */
var fatal = function (label, describe, error, tags) {
    capture("fatal", label, describe, error, tags);
};
/**
 * 普通错误
 * @params level 错误级别，"fatal" | "error" | "warn"
 * @param label 标记 标示自己的业务模块 必填
 * @param describe 描述 必填
 * @param error Error 选填
 * @param tags 额外信息 选填
 */
var error = function (label, describe, error, tags) {
    capture("error", label, describe, error, tags);
};
/**
 * 警告
 * @params level 错误级别，"fatal" | "error" | "warn"
 * @param label 标记 标示自己的业务模块 必填
 * @param describe 描述 必填
 * @param error Error 选填
 * @param tags 额外信息 选填
 */
var warn = function (label, describe, error, tags) {
    capture("warn", label, describe, error, tags);
};
export var logger = {
    fatal: fatal,
    error: error,
    warn: warn,
    custom: custom,
};
//# sourceMappingURL=index.js.map